export default __webpack_public_path__ + "static/media/IPL.734b7878.png";